import { render, staticRenderFns } from "./SupportTypeProblemLabel.vue?vue&type=template&id=2b2bf189"
import script from "./SupportTypeProblemLabel.vue?vue&type=script&lang=js"
export * from "./SupportTypeProblemLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports